(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["viewed-products-drawer"] && !Shopify.designMode) return;
  try {
    class ViewedProductsDrawer extends HTMLElement {
    connectedCallback() {
      if (window.Shopify?.designMode) return;

      requestAnimationFrame(() => {
        this.#autoOpen();
      });
    }

    #autoOpen() {
      const rawMinutes = parseInt(this.dataset.inactivityPeriod);
      const minutes = isNaN(rawMinutes) ? 30 : rawMinutes;
      const inactivityMs = minutes * 60 * 1000;
      const lastVisit = localStorage.getItem('taylorswines:lastViewedTimestamp');
      const referrer = document.referrer ? new URL(document.referrer).origin : '';
      const isExternal = referrer !== window.location.origin;
      const elapsed = lastVisit ? Date.now() - parseInt(lastVisit) : null;

      if (lastVisit && elapsed > inactivityMs && isExternal) {
        const drawer = this.querySelector('x-drawer');
        drawer?.show();
      }

      localStorage.setItem('taylorswines:lastViewedTimestamp', Date.now().toString());
    }
  }

  if (!window.customElements.get('viewed-products-drawer')) {
    window.customElements.define('viewed-products-drawer', ViewedProductsDrawer);
  }
  } catch(e) { console.error(e); }
})();

})();
